
import { Pipe, PipeTransform } from '@angular/core';


export const makePrettyNumber = (input: string | number, decimal = 2, multiplyBy = 1, negativeParans = false, hideZeroFraction = false): string => {
  let n: number
  try {
    n = parseFloat(input as string) * multiplyBy
  } catch (e) {
    return "NaN"
  }
  const neg = n < 0
  const int = Math.floor(n)
  const intText = (negativeParans && neg ? -int : int).toLocaleString("en-US")
  if (!decimal) return intText
  const fract = (n - int).toFixed(2).split(".")[1]

  if (hideZeroFraction && !parseInt(fract)) return intText
  const numberText = `${intText}.${fract}`
  // console.log({ int, fract })
  return negativeParans && neg ? `(${numberText})` : numberText
}

@Pipe({
    name: 'prettyNumbers',
    standalone: true
})
export class PrettyNumbersPipe implements PipeTransform {
    transform(input: any, decimal = 2, multiplyBy = 1, negativeParans = false, hideZeroFraction = false): string {
      return makePrettyNumber(input, decimal, multiplyBy, negativeParans, hideZeroFraction)
    }
}

@Pipe({
    name: 'getNumber',
    standalone: true
})
export class GetNumberPipe implements PipeTransform {
    transform(input: any): number {
      if (isNaN(input)) return 0
      return input as number
    }
}

